import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useInternalGetCaseById } from 'core/types'

import ModelLink from './ModelLink'

type CaseLinkProps = {
  caseId: string
}

const CaseLink: FC<CaseLinkProps> = ({ caseId }) => {
  const [_, { companyId, personId }] = useQueryApi()
  const { data: caseData, isLoading } = useInternalGetCaseById({
    companyId,
    personId,
    caseId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return <ModelLink id={caseId} isLoading={isLoading} model={caseData} />
}

export default CaseLink
